export interface AboutProps {}

export const useAbout = (props: AboutProps) => {
  return {
    ...props,
  }
}
